import loadable from '@loadable/component';
export const manifest = {
  'IconView.Circle': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "IconViewCircle";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "IconViewCircle" */
          './circle'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./circle");
            }

            return eval('require.resolve')("./circle");
          }

        }, {
          resolveComponent: m => m.IconViewCircle
        })
      }
    }
  },
  'IconView.SuperEllipse': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "IconViewSuperEllipse";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "IconViewSuperEllipse" */
          './super-ellipse'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./super-ellipse");
            }

            return eval('require.resolve')("./super-ellipse");
          }

        }, {
          resolveComponent: m => m.IconViewSuperEllipse
        })
      }
    }
  },
  'IconView.Rectangle': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "IconViewRectangle";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "IconViewRectangle" */
          './rectangle'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./rectangle");
            }

            return eval('require.resolve')("./rectangle");
          }

        }, {
          resolveComponent: m => m.IconViewRectangle
        })
      }
    }
  },
  'IconView.NoShape': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "IconViewNoShape";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "IconViewNoShape" */
          './no-shape'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./no-shape");
            }

            return eval('require.resolve')("./no-shape");
          }

        }, {
          resolveComponent: m => m.IconViewNoShape
        })
      }
    }
  }
};